module.exports = __webpack_public_path__ + "static/img/OOSH_028.fb9334c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_028.jpg
// module id = v6W3
// module chunks = 170